import { render } from "./SchoolDiaryCreate.vue?vue&type=template&id=59b1e8e2&scoped=true&ts=true"
import script from "./SchoolDiaryCreate.vue?vue&type=script&lang=ts"
export * from "./SchoolDiaryCreate.vue?vue&type=script&lang=ts"

import "./SchoolDiaryCreate.vue?vue&type=style&index=0&id=59b1e8e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59b1e8e2"]])

export default __exports__